/**
 * Hook for changing the html document title
 */
export const useDocumentTitle = () => {
    return (title: string) => {
        document.title = `Property Tax Portal | ${title}`;
    };
};
